import {
  Banner,
  useApi,
  useTranslate,
  reactExtension, InlineStack, Text, BlockStack,
  Grid,
  Heading,
  Image,
  TextBlock,
  useSettings,
  useCartLines
} from '@shopify/ui-extensions-react/checkout';
import {useEffect, useState} from "react";

export default reactExtension(
  'purchase.checkout.block.render',
  () => <Extension/>,
);

function Extension() {
  const translate = useTranslate();
  const {extension} = useApi();
  const {
    title_1, content_1,
    title_2, content_2,
    title_3, content_3, content_3_custom,
    title_4, content_4,
    title_5, content_5,
  } = useSettings();

  const cartLines = useCartLines();

  const [reviews1, setReviews1] = useState([]);

  useEffect(() => {
    let isCustom = false;
    cartLines.forEach((item) => {

      if (item.merchandise.title.indexOf('Custom ') !== -1) {
        isCustom = true
      }
    })
    let reviews = [];
    if (title_1 && title_1 != '') {
      reviews.push({'title': title_1, 'content': content_1})
    }
    if (title_2 && title_2 != '') {
      reviews.push({'title': title_2, 'content': content_2})
    }
    if (title_3 && title_3 != '') {
      reviews.push({'title': title_3, 'content': isCustom ? content_3_custom : content_3})
    }
    if (title_4 && title_4 != '') {
      reviews.push({'title': title_4, 'content': content_4})
    }
    if (title_5 && title_5 != '') {
      reviews.push({'title': title_5, 'content': content_5})
    }
    setReviews1(reviews)

  }, []);


  return (
    <BlockStack>
      {
        reviews1.map((el) => (<BlockStack border="base" cornerRadius="base" borderWidth="base" padding="base">
          <Grid columns={['fill', 118]}>
            <Heading>{el.title}</Heading>
            <Grid columns={[17, 'fill']} spacing="extraTight"><Image fit="cover"
                                                                     source="https://cdn.shopify.com/s/files/1/0732/5909/0212/files/verified-symbol-icon.svg?v=1706803778"/>
              <Text appearance={"success"}>Verified Buyer</Text>
            </Grid>
          </Grid>
          <InlineStack spacing="extraTight">
            <Image
              source="https://www.seatcoversolutions.com/cdn/shop/t/7/assets/star.svg?v=152075737512081534321704990686"/>
            <Image
              source="https://www.seatcoversolutions.com/cdn/shop/t/7/assets/star.svg?v=152075737512081534321704990686"/>
            <Image
              source="https://www.seatcoversolutions.com/cdn/shop/t/7/assets/star.svg?v=152075737512081534321704990686"/>
            <Image
              source="https://www.seatcoversolutions.com/cdn/shop/t/7/assets/star.svg?v=152075737512081534321704990686"/>
            <Image
              source="https://www.seatcoversolutions.com/cdn/shop/t/7/assets/star.svg?v=152075737512081534321704990686"/>
          </InlineStack>
          <TextBlock inlineAlignment={'start'}>
            {el.content}
          </TextBlock>
        </BlockStack>))
      }

    </BlockStack>
  );
}
